import {
    handleLists,
    handleMaxMin,
    handleRateList,
    updateAlerts,
} from 'common/utils/helpers';

/**
 * Builder para preparar valores de actualización desde el API
 * @param {Object} values - Valores desde el API
 * @param {Object} initialValues - Valores iniciales del formulario
 * @returns {Object} Valores preparados para el formulario
 */
export const createPrepareUpdateValuesBuilder =
    (config = {}) =>
    (values, initialValues) => {
        const rules = {};
        values.financier_product_rules.forEach((rule) => {
            rules[rule.key] = rule.value;
        });

        const amount_values = handleMaxMin(rules.amount_values);
        const power_values = handleMaxMin(rules.power_values);
        const rate_list = handleRateList(rules.rate_list);
        const accesories_list_optional = handleLists(
            rules.accesories_list_optional,
        );
        const catalog_documents = handleLists(values.catalog_documents);

        const terms = values.parameters[0]
            ? values.parameters[0].terms.split(',')
            : [];

        const insurance_product =
            values.financier_product_insurance &&
            values.financier_product_insurance.length > 0
                ? values.financier_product_insurance[0].id
                : '';

        const baseValues = {
            accesories_list_must_have: rules.accesories_list_must_have,
            accesories_list_optional: accesories_list_optional,
            alerts: updateAlerts(values.alerts, initialValues.alerts),
            amount_values: {
                isChecked: values.parameters.length
                    ? values.parameters[0].blind_objects.includes(
                          'amount_values',
                      )
                    : false,
                max: amount_values[1],
                min: amount_values[0],
            },
            catalog_documents: catalog_documents,
            description: values.description,
            disabled: values.disabled,
            financier: values.financier,
            id: values.id,
            inverters_list: rules.inverters_list,
            insurance_product,
            name: values.name,
            panels_list: rules.panels_list,
            parameters: values.parameters.length
                ? {
                      ...values.parameters[0],
                      terms,
                  }
                : {},
            parameters_commission_credit: {
                isChecked: values.parameters.length
                    ? values.parameters[0].blind_objects.includes(
                          'commission_credit',
                      )
                    : false,
                opening_commission_vat: values.parameters.length
                    ? values.parameters[0].opening_commission_vat
                    : 0,
                unit: values.parameters.length
                    ? values.parameters[0].is_commission_percentage
                        ? 0
                        : 1
                    : 1,
                value: values.parameters.length
                    ? values.parameters[0].commission_credit
                    : 0,
            },
            parameters_hitch: {
                isChecked: values.parameters.length
                    ? values.parameters[0].blind_objects.includes('hitch')
                    : false,
                unit: values.parameters.length
                    ? values.parameters[0].is_percentage
                        ? 0
                        : 1
                    : 1,
                value: values.parameters.length
                    ? values.parameters[0].hitch
                    : 0,
            },
            parameters_rate: {
                isChecked: values.parameters.length
                    ? values.parameters[0].blind_objects.includes('rate')
                    : false,
                value: values.parameters.length ? values.parameters[0].rate : 0,
            },
            power_values: {
                isChecked: values.parameters.length
                    ? values.parameters[0].blind_objects.includes(
                          'power_values',
                      )
                    : false,
                max: power_values[1],
                min: power_values[0],
            },
            rate_list: rate_list,
            status_flag: values?.status_flag,
            template: values?.template?.id,
            type: values.type,
            type_algorithm: values.type_algorithm,
            types_business_company: values.types_business_company,
        };

        // Permitir extensiones del partner
        if (config.extendPrepareValues) {
            return config.extendPrepareValues(baseValues, values, rules);
        }

        return baseValues;
    };

/**
 * Builder por defecto sin extensiones
 */
export const getPrepareUpdateValues = (initialValues) =>
    createPrepareUpdateValuesBuilder()(undefined, initialValues);
